import React from 'react';
import { useTranslation } from 'react-i18next';
import { CallState, SAPContact, SAPContactSearchState } from '../../types';
import { SearchForm, SearchParams } from './SearchForm';
import { SapContactListSection } from './SapContactListSection';
import { ManualSearchState } from './sap-contact.types';

interface CallCardSapSectionsProps {
  callState: CallState;
  sapContactState?: SAPContactSearchState;
  manualSearchState?: ManualSearchState;
  linkedSapContactId: string | null;
  onLink: (contact: SAPContact) => void;
  onManualSearch?: (params: SearchParams) => void;
}

export function CallCardSapSections({
  callState,
  sapContactState,
  manualSearchState,
  linkedSapContactId,
  onLink,
  onManualSearch,
}: CallCardSapSectionsProps) {
  const { t } = useTranslation();

  const showManualSearchSection =
    manualSearchState &&
    (manualSearchState.contacts.length > 0 ||
      manualSearchState.isLoading ||
      manualSearchState.error);

  return (
    <>
      {sapContactState && (
        <SapContactListSection
          headerIcon={
            <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
            </svg>
          }
          headerLabel={t('call:sap.autoMatchedContacts', {
            count: sapContactState.contacts.length,
          })}
          contacts={sapContactState.contacts}
          isLoading={sapContactState.isLoading}
          error={sapContactState.error}
          emptyMessage={t('call:sap.noContactsFound')}
          loadingMessage={t('call:sap.searchingContacts')}
          callerNumber={callState.callerNumber}
          linkedSapContactId={linkedSapContactId}
          // Keep Link available even for a single match — auto-open can fail/race.
          showActions={(count) => count > 0}
          onLink={onLink}
        />
      )}

      {showManualSearchSection && manualSearchState && (
        <SapContactListSection
          headerIcon={
            <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
              <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
          }
          headerLabel={t('call:sap.manualSearchResults', {
            count: manualSearchState.contacts.length,
          })}
          contacts={manualSearchState.contacts}
          isLoading={manualSearchState.isLoading}
          error={manualSearchState.error}
          emptyMessage={t('call:sap.noContactsFoundGeneric')}
          loadingMessage={t('call:sap.searching')}
          callerNumber={callState.callerNumber}
          linkedSapContactId={linkedSapContactId}
          showActions={() => true}
          onLink={onLink}
        />
      )}

      {sapContactState && onManualSearch && (
        <SearchForm onSearch={onManualSearch} isLoading={manualSearchState?.isLoading} />
      )}
    </>
  );
}

export default CallCardSapSections;
